<template>
  <UApp :toaster="{ position: 'top-right', duration: 5000, expand: false }">
    <NuxtLoadingIndicator color="var(--bp-ink)" />
    <NuxtLayout>
      <NuxtPage />
    </NuxtLayout>
  </UApp>
</template>

<script setup>
// TODO: Move PostHog server-side tracking to API route or server middleware
// posthog-node cannot be imported in client-side code (app.vue runs on both client and server)
// import { PostHog } from 'posthog-node'

// const { data: someData, error } = await useAsyncData('ctaText', async () => {
//   const runtimeConfig = useRuntimeConfig()
//   const posthog = new PostHog(
//     runtimeConfig.public.posthogPublicKey,
//     { host: runtimeConfig.public.posthogHost },
//   )
//
//   const cookies = useCookie(`ph_${runtimeConfig.public.posthogPublicKey}_posthog`)
//   if (cookies && cookies.value) {
//     try {
//       const distinctId = cookies.value.distinct_id // or you can use your user's email, for example.
//       posthog.capture({
//         distinctId: distinctId,
//         event: 'user_did_something"',
//       })
//       await posthog.shutdown()
//     }
//     catch (error) {
//       console.log(error)
//     }
//   }
//   return 'Some data'
// })
</script>
